import ServiceGraphQL from 'src/service/gql-service';
import { removeIndividual } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const RemoveIndividual = (_id) => {
  const params = {
    query: removeIndividual.QUERY,
    variables: {
      filter: {
        _id
      }
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.recordId;
    })
    .catch((err) => {
      throw err;
    });
};
